export default {
	meta(name, cb, ecb) {
		this.http
			.get('/cupping/meta/' + name, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb, ecb) {
		this.http
			.get('/cupping', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/cupping', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getById(id, cb) {
		this.http.get('/cupping/' + id, {}).then((r) => cb && cb(r))
	},
	remove(id, cb) {
		this.http.delete('/cupping/' + id, {}).then((r) => cb && cb(r))
	},
	searchSample(params, cb, ecb) {
		this.http
			.get('/cupping/sample', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	updateSample(form, cb, ecb) {
		this.http
			.post('/cupping/sample', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getSampleById(id, cb) {
		this.http.get('/cupping/sample/' + id, {}).then((r) => cb && cb(r))
	},
	removeSample(id, cb, ecb) {
		this.http
			.delete('/cupping/sample/' + id)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchScore(params, cb, ecb) {
		this.http.get('/cupping/score', { params }).then((r) => cb && cb(r))
	},
	getScoreById(id, cb) {
		this.http.get('/cupping/score/' + id, {}).then((r) => cb && cb(r))
	},
	updateScore(form, cb, ecb) {
		this.http
			.post('/cupping/score', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	addUserScore(form, cb, ecb) {
		this.http
			.post('/cupping/score/useradd', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getSampleScoreSummary(id, cb) {
		this.http.get(`/cupping/sample/${id}/scoresummary`, {}).then((r) => cb && cb(r))
	}
}
